import {
  Get2SAGetRequestModel,
  Update2SAPutRequestModel,
  Generate2SACodePostRequestModel,
  Verify2SACodePostRequestModel,
  Verify2SAReleaseCodePostRequestModel,
} from "@/features/two-step-authentication/services/two-step-authentication-model";
import { TwoStepAuthApi } from "@/features/two-step-authentication/services/two-step-authentication-api";

export class TwoStepAuthService {
  private twoStepAuthApi = new TwoStepAuthApi();

  /**
   * 2段階認証情報取得
   */
  public async getTwoStepAuth(param: Get2SAGetRequestModel) {
    return await this.twoStepAuthApi.getTwoStepAuth(param);
  }

  /**
   * 2段階認証情報更新
   */
  public async updateTwoStepAuth(param: Update2SAPutRequestModel) {
    return await this.twoStepAuthApi.putUpdateTwoStepAuth(param);
  }

  /**
   * 2段階認証コード発行
   */
  public async generateTwoStepAuthCode(param: Generate2SACodePostRequestModel) {
    return await this.twoStepAuthApi.postGenerateTwoStepAuthCode(param);
  }

  /**
   * 2段階認証コード検証
   */
  public async verifyTwoStepAuthCode(param: Verify2SACodePostRequestModel) {
    return await this.twoStepAuthApi.postVerifyTwoStepAuthCode(param);
  }

  /**
   * 2段階認証解除コード検証
   */
  public async verifyTwoStepAuthReleaseCode(param: Verify2SAReleaseCodePostRequestModel) {
    return await this.twoStepAuthApi.postVerifyTwoStepAuthReleaseCode(param);
  }
}